export const FilterButton = ({
  label,
  selectedOptions,
  setSelectedOptions,
  maxSelected,
}) => {
  const isActive = selectedOptions.includes(label);
  const isDisabled = !isActive && selectedOptions.length >= maxSelected;

  const toggleOption = () => {
    if (isDisabled) return; // Prevent toggling if the button is disabled
    if (isActive) {
      // Remove the label from the selected options
      setSelectedOptions(selectedOptions.filter((option) => option !== label));
    } else {
      // Add the label to the selected options
      setSelectedOptions([...selectedOptions, label]);
    }
  };

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        toggleOption();
      }}
      disabled={isDisabled}
      className={`py-2 px-6 border rounded-full justify-center items-center flex text-sm  ${
        isActive
          ? "bg-black/5 border-black ring-1 ring-black ring-offset-0 border-black/70"
          : "border-gray-400 hover:border-gray-600 hover:bg-black/5"
      } ${
        isDisabled
          ? "opacity-50 cursor-not-allowed"
          : "transform transition-transform active:scale-95"
      } `}
    >
      {label}
    </button>
  );
};
